import { Button } from '@/components/ui/Button';
import { ConfirmDialog } from '@/components/ui/ConfirmDialog';
import { useSuspendOrganisation, useActivateOrganisation, useDeleteOrganisation } from '@/hooks/useAdminOrganisations';
import { Ban, CheckCircle, Trash2 } from 'lucide-react';
import { useState } from 'react';

interface OrgActionsMenuProps {
  orgUuid: string;
  status: string;
}

export function OrgActionsMenu({ orgUuid, status }: OrgActionsMenuProps) {
  const [confirmDelete, setConfirmDelete] = useState(false);
  const suspend = useSuspendOrganisation();
  const activate = useActivateOrganisation();
  const deleteOrg = useDeleteOrganisation();

  return (
    <div className="flex flex-wrap gap-2">
      {status === 'active' ? (
        <Button
          variant="outline"
          size="sm"
          icon={<Ban className="h-3.5 w-3.5" />}
          onClick={() => suspend.mutate(orgUuid)}
          loading={suspend.isPending}
        >
          Suspendre
        </Button>
      ) : (
        <Button
          variant="outline"
          size="sm"
          icon={<CheckCircle className="h-3.5 w-3.5" />}
          onClick={() => activate.mutate(orgUuid)}
          loading={activate.isPending}
        >
          Activer
        </Button>
      )}
      <Button
        variant="danger"
        size="sm"
        icon={<Trash2 className="h-3.5 w-3.5" />}
        onClick={() => setConfirmDelete(true)}
      >
        Supprimer
      </Button>
      <ConfirmDialog
        isOpen={confirmDelete}
        onClose={() => setConfirmDelete(false)}
        onConfirm={() => deleteOrg.mutate(orgUuid)}
        title="Supprimer l'organisation"
        message="Cette action supprimera l'organisation et toutes ses données associées."
        confirmLabel="Supprimer"
        loading={deleteOrg.isPending}
      />
    </div>
  );
}
